import { BaseService } from './base.service';

export class ReceiptService extends BaseService {
    baseUrl = '/receipt';
}
